<script setup lang="ts">
import { useMeta } from '~/composables/common/use-meta'
import { useHiddenToScroll } from '~/composables/use-hidden-to-scroll'
import { AccountRouteEnum, AuthTabEnum, RoutesEnum } from '~/enums'
import { PROFILE_MENUS_MOBILE } from '~/resources/menus'

const { openAuthModal } = useAuth()
const { isLogged, formattedBalance } = useUser()
const authStore = useAuthStore()
const isMenuOpened = ref(false)
const { currentMeta } = useMeta()
const { isVisible: isHeaderVisible } = useHiddenToScroll({ defaultValue: true })
const $isLighthouseBot = useNuxtApp().$isLighthouseBot as boolean

const isSidebarOpened = computed({
  get: () => authStore.isSidebarOpen,
  set: (value) => authStore.setIsSidebarOpen(value),
})
const route = useRoute()

const toggleSidebar = () => {
  isSidebarOpened.value = !isSidebarOpened.value
}

const closeSidebar = () => {
  isSidebarOpened.value = false
}
const isShowWelcomeModal = computed(() => {
  return authStore.enableWelcomeModal || false
})

watch(
  () => route.fullPath,
  () => {
    authStore.setEnableWelcomeModal(false)
  },
  { immediate: true },
)
const openModalWithLogin = () => {
  authStore.setSelectedAuthTab(AuthTabEnum.Login)
  openAuthModal()
  closeSidebar()
}

const openModalWithRegister = () => {
  authStore.setSelectedAuthTab(AuthTabEnum.Register)
  openAuthModal()
  closeSidebar()
}

onMounted(() => {
  if (route.query?.token && route.path === AccountRouteEnum.ResetPassword) {
    authStore.setForgotPasswordStepReset(true)
  }
  if (document) {
    document.querySelectorAll('[aria-haspopup="menu"]').forEach((item) => {
      item?.removeAttribute('aria-haspopup')
      item?.removeAttribute('aria-owns')
      item?.removeAttribute('aria-expanded')
    })
  }
})
</script>
<template>
  <div class="wrapper-header">
    <div
      class="mobile-header"
      :class="{ 'mobile-header--hidden': !isHeaderVisible }"
    >
      <div class="mobile-header__left">
        <div
          class="mobile-header__left__hamburger"
          button-id="toggle-sidebar"
          button-name="toggle-sidebar"
          @click="toggleSidebar"
        >
          <img
            src="/images/header/icon-hamburger-pc.svg"
            alt="icon hamburger"
            width="24"
            height="24"
          />
        </div>
        <h1 :title="currentMeta.meta_title" class="image-logo">
          <NuxtLink :to="RoutesEnum.Home">
            <img
              class="mobile-header__logo"
              src="/images/logo/logo.svg"
              alt="logo"
              @click="closeSidebar"
            />
          </NuxtLink>
        </h1>
      </div>
      <div class="mobile-header__right" @click="closeSidebar">
        <template v-if="isLogged">
          <div class="mobile-header__balance">
            <div class="mobile-header__balance-icon icon-wallet" />
            <div class="mobile-header__balance-separator" />
            <span class="mobile-header__balance-value">
              <ClientOnly>{{ formattedBalance }}</ClientOnly>
            </span>
          </div>
          <div class="mobile-header__avatar">
            <BaseMenu
              v-model="isMenuOpened"
              :items="PROFILE_MENUS_MOBILE"
              :is-use-model-value="true"
              :open-on-focus="false"
              custom-class="profile-menu"
            >
              <img
                :class="[
                  'mobile-header__avatar-img',
                  {
                    'mobile-header__avatar-img--focus': isMenuOpened,
                  },
                ]"
                src="/assets/images/avatar/avatar-1.webp"
                alt="avatar"
              />
            </BaseMenu>
          </div>
        </template>
        <template v-else>
          <BaseButton
            size="small"
            variant="outline"
            label="Đăng nhập"
            button-id="open-modal-login"
            button-name="open-modal-login"
            @click="openModalWithLogin"
          />
          <BaseButton
            size="small"
            variant="primary"
            label="Đăng ký"
            button-id="open-modal-register"
            button-name="open-modal-register"
            @click="openModalWithRegister"
          />
        </template>
      </div>
    </div>
    <MobileCommonHamburgerMenu v-if="!$isLighthouseBot" v-model="isSidebarOpened" />
    <ModalWelcome :is-show-welcome-modal="isShowWelcomeModal" />
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/styles/components/mobile/header/index.scss';
</style>
